type ResellerLike = {
    settings?: {
        administration?: {
            showColliBarcodeSpecification?: boolean
        }
    }
}

type CustomerLike = {
    settings?: {
        orders?: {
            showColliBarcodeSpecification?: '' | 'default' | 'yes'
        }
    }
}

// The customer setting overrules the reseller setting, '' means explicitly off and 'default' (or missing) falls back to the reseller
export function showColliBarcodeSpecification(reseller?: ResellerLike, customer?: CustomerLike | null) {
    const customerSetting = customer?.settings?.orders?.showColliBarcodeSpecification

    if (customerSetting === 'yes') {
        return true
    }

    if (customerSetting === '') {
        return false
    }

    return !!reseller?.settings?.administration?.showColliBarcodeSpecification
}
